module.exports = __webpack_public_path__ + "static/sparky-0ad99abbaf8d29686e2009852ff465eb.svg";